import './StyledTable.scss';

const StyledTable = (props) =>
{
  return (
    <div className="styledTable">
      {props.children}
    </div>
  );
}

export default StyledTable;
